import { Component } from 'preact'
import TextButton from '../ui-components/TextButton'

export default class extends Component {
  constructor () {
    super()
    this.documentClick = this.documentClick.bind(this)
  }
  addHandler () {
    window.document.addEventListener('click', this.documentClick)
  }
  removeHandler () {
    window.document.removeEventListener('click', this.documentClick)
  }
  documentClick (e) {
    if (!this.root.contains(e.target)) {
      this.removeHandler()
      this.setState({ isOpen: false })
    }
  }
  render (props) {
    const Trigger = props.triggerElement || TextButton
    return <div className={props.className} ref={ref => { this.root = ref }}>
      <Trigger
        onClick={() => {
          if (!this.state.isOpen) {
            this.addHandler()
          } else {
            this.removeHandler()
          }
          this.setState({ isOpen: !this.state.isOpen })
        }}>
        {props.trigger}
      </Trigger>
      {this.state.isOpen
        ? <div class={props.class}>
          {props.children}
        </div>
        : null}
    </div>
  }
}
